import { motion } from "framer-motion";

export default function EtFounderNote() {

  // First Created - 22 Nov 2025
  // Author - Atul Pandey
  // Purpose — Et Founder's Notes
  // Updated - 22 Nov 2025 - Cinematic Emotional Finale — Warm, Intimate, Reflective
  // Updated - 23 Nov 2025 - Copy and visual refinement
  // Updated - 24 Nov 2025 - Copy refinement
  
  return (

    <section className="relative overflow-hidden py-32 bg-black text-white">

      {/* --- 1. Background Gradient (Calm, Warm) --- */}
      {/* <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-orange-900/10"></div> */}

      {/* --- 2. Soft Fog Layer (Slow breathing motion) --- */}
      {/* <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_80%,rgba(255,125,10,0.08),transparent_75%)] animate-founder-fog"></div>
      </div> */}

      {/* --- 3. Subtle Spotlight Column Behind Text --- */}
      {/* <div
        className="
          absolute left-1/2 top-0 -translate-x-1/2
          w-[500px] h-full
          bg-gradient-to-b from-orange-500/10 via-orange-400/5 to-transparent
          blur-[80px]
        "
      ></div> */}

      {/* --- 1. Background Gradient (Deep Warm Black) --- */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-orange-900/15"></div>

      {/* --- 2. Warm Fog Layer --- */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_80%,rgba(255,125,10,0.12),transparent_75%)] animate-founder-fog"></div>
      </div>

      {/* --- 3. Warm Spotlight Column Behind Text --- */}
      <div
        className="
          absolute left-1/2 top-0 -translate-x-1/2
          w-[500px] h-full
          bg-gradient-to-b from-orange-500/20 via-orange-400/10 to-transparent
          blur-[90px]
        "
      ></div>


      {/* --- 4. Minimal Floating Sparks --- */}
      <div className="pointer-events-none absolute inset-0">
        {[...Array(120)].map((_, i) => (
          <div
            key={i}
            className="absolute w-[3px] h-[3px] bg-orange-300/10 rounded-full animate-founder-spark"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 8}s`,
              animationDuration: `${8 + Math.random() * 7}s`,
            }}
          ></div>
        ))}
      </div>

      {/* --- 5. Content Block --- */}
      <div className="relative z-20 max-w-4xl mx-auto px-8">

        {/* Heading */}
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-orange-500 mb-8 drop-shadow-[0_0_15px_rgba(255,125,0,0.25)]"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
        >
          {/* A Note From Our Founder */}
          A Message From the Founder
        </motion.h2>

        {/* Underline Motif */}
        <motion.div
          className="w-24 h-[3px] bg-gradient-to-r from-orange-600 to-orange-400 rounded-full mb-10 opacity-70"
          initial={{ width: 0, opacity: 0 }}
          whileInView={{ width: 96, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.4 }}
        ></motion.div>

        {/* Narrative */}
        {/* 23 Nov 2025 Copy */}
        <motion.div
          className="text-lg leading-relaxed text-gray-300 space-y-8 font-extralight"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.35 }
            }
          }}
        >

          {/* Paragraph 1 */}
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            Trinity was not built as a product idea. It was shaped through decades of lived
            experience. Watching leaders navigate growth, complexity, uncertainty,
            breakthroughs, and the quiet moments that define how they think and operate.
          </motion.p>

          {/* Paragraph 2 */}
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            Over time, something became clear. Leaders do not need more tools or dashboards.
            They need <span className="text-orange-600">clarity</span>. They need 
            <span className="text-orange-600"> rhythm</span>. They need a way to connect their inner 
            purpose with the outer performance they want to create — day after day.
          </motion.p>

          {/* Paragraph 3 */}
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            Trinity was built to support that journey. To help you understand yourself more
            deeply. To sharpen your intent. To strengthen your daily momentum. And to help
            you show up in ways that move your world forward with 
            <span className="text-orange-600"> purpose</span> and 
            <span className="text-orange-600"> coherence</span>.
          </motion.p>

          {/* Paragraph 4 */}
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            My hope is that Trinity becomes a companion for you. A space to think, a place
            to anchor, and a rhythm that carries you toward the leader you know you can be.
          </motion.p>

          <motion.p
            className="text-lg text-gray-300 leading-relaxed font-extralight mt-10"
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            On behalf of <span className="text-orange-600 font-semibold">Eternity</span>, 
            we invite you to take the first step.  
            {/* <br /> */}
            <span className="text-orange-600 font-semibold"> Trinity</span> is ready to walk with you.
          </motion.p>

        </motion.div>

        


        <motion.div
          variants={{
            hidden: { opacity: 0, y: 20 },
            visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
          }}
          className="pt-6 text-lg text-gray-300 font-light"
        >
          Warm regards,<br />
          <span className="not-italic font-extralight text-orange-500">
            Atul Pandey
          </span>
          <br />
          <span className="text-gray-400 text-base">
            Founder & CEO, Eternity Solutions Corp.
          </span>
        </motion.div>


        {/* <motion.div
          className="text-lg leading-relaxed text-gray-300 space-y-8 font-extralight"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.35 }
            }
          }}
        >
          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            Trinity wasn’t built as a product idea. It was built from lived
            experience — decades of watching leaders navigate complexity, growth,
            setbacks, breakthroughs, and the quiet, unseen moments that shape how
            they think and operate.
          </motion.p>

          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            It became clear that leaders don’t need more tools. They need clarity.
            They need rhythm. They need a way to connect their inner purpose to
            the outer performance they want to create — consistently.
          </motion.p>

          <motion.p
            variants={{
              hidden: { opacity: 0, y: 20 },
              visible: { opacity: 1, y: 0, transition: { duration: 1.1 } }
            }}
          >
            My hope is that Trinity becomes a companion for you on that journey —
            helping you see yourself more clearly, shape your path intentionally,
            and show up every day with purpose and momentum.
          </motion.p>
        </motion.div> */}
      </div>

      {/* --- Motion Keyframes --- */}
      <style>{`
        @keyframes founderFog {
          0% { transform: translateY(0); opacity: 0.6; }
          50% { transform: translateY(-15px); opacity: 0.75; }
          100% { transform: translateY(0); opacity: 0.6; }
        }
        .animate-founder-fog {
          animation: founderFog 14s ease-in-out infinite;
        }

        @keyframes founderSpark {
          0% { transform: translateY(0) scale(0.6); opacity: 0.15; }
          50% { transform: translateY(-20px) scale(1); opacity: 0.45; }
          100% { transform: translateY(0) scale(0.6); opacity: 0.15; }
        }
        .animate-founder-spark {
          animation: founderSpark linear infinite;
        }
      `}</style>

    </section>
    // <section className="py-20 bg-black text-white">
    //   <div className="max-w-4xl mx-auto px-4 text-center">
    //     <motion.h2
    //       className="text-3xl font-bold text-orange-600 mb-6"
    //       initial={{ opacity: 0 }}
    //       whileInView={{ opacity: 1 }}
    //       viewport={{ once: true }}
    //     >
    //       A Note from Our Founder
    //     </motion.h2>

    //     <motion.p
    //       className="text-gray-300 text-lg leading-relaxed"
    //       initial={{ opacity: 0 }}
    //       whileInView={{ opacity: 1 }}
    //       viewport={{ once: true }}
    //     >
    //       {/* Replace with your actual writing */}
    //       The journey of building Trinity wasn’t just about technology. It was
    //       about capturing the essence of human growth — clarity, reflection, and
    //       purposeful action…
    //     </motion.p>
    //   </div>
    // </section>
  );
}